<template>
  <div id="app" class="cfw-page">
   
    <div class="header-container">
      <FDCAHeader 
      :EditStatus="EditStatus" 
      :ServiceCurrentStep="ServiceCurrentStep" 
      :PathName="PathName" 
      />
    </div>
    <!--:active_modal="active_modal"-->

    <router-view :EditStatus="EditStatus" :session_id="session_id" />
    
    
    <!-- <div class="content-container" id="" v-if="this.Container1 == false">   
      <v-container grid-list-xl id=""  >
        <v-layout row wrap>
          <v-flex xs12 sm12 md12 lg12 xl12 class="router-content">
              <router-view :EditStatus="EditStatus" :session_id="session_id" />
              :overlay="overlay"
              <component v-bind:is="layout"></component>
          </v-flex>  
        </v-layout>
      </v-container>
    </div>

    <div class="content-container1" v-if="this.Container1 == true">
        <router-view :EditStatus="EditStatus" :session_id="session_id" /> 
        <component v-bind:is="layout"></component>
    </div> -->

    <div id="hidden-icons" style="visibility: hidden; position: absolute;">
        <IconBase><IconArrowBack /></IconBase>
        <IconBase><IconArrowForward /></IconBase>
        <IconBase><IconBackDate /></IconBase>
        <IconBase><IconBusinessPhone /></IconBase>
        <IconBase><IconCashSearch /></IconBase>
        <IconBase><IconCheck /></IconBase>
        <IconBase><IconCustomerSupport /></IconBase>
        <IconBase><IconDisk /></IconBase>
        <IconBase><IconDualEducator /></IconBase>
        <IconBase><IconEducator /></IconBase>
        <IconBase><IconEmail /></IconBase>
        <IconBase><IconFeedback /></IconBase>
        <IconBase><IconInformation /></IconBase>
        <IconBase><IconLegalScales /></IconBase>
        <IconBase><IconMinus /></IconBase>
        <IconBase><IconMobilePhone /></IconBase>
        <IconBase><IconPencil /></IconBase>
        <IconBase><IconPlus /></IconBase>
        <IconBase><IconPoliceCheck /></IconBase>
        <IconBase><IconRefresh /></IconBase>
        <IconBase><IconSearch /></IconBase>
        <IconBase><IconService /></IconBase>
        <IconBase><IconStar /></IconBase>
        <IconBase><IconStarCheck /></IconBase>
        <IconBase><IconAddCard /></IconBase>
    </div>

    <div class="footer-container">
      <!-- <FDCAProgress :PathName="PathName" v-show="this.hideProgressBar == false"/> -->
      <FDCAFooter />
        
    </div>
  </div>
</template>

<style lang="css">
    .mb-10 {
        margin-bottom: 10px;
    }
    .mb-20 {
        margin-bottom: 20px;
    }
    .mb-30 {
        margin-bottom: 30px !important;
    }
    .mb-40 {
        margin-bottom: 40px !important;
    }
    .mb-50 {
        margin-bottom: 50px !important;
    }
    .mb-100 {
        margin-bottom: 100px !important;
    }
    .transparent-button {        
        align-items: center;
        border-radius: 30pt;
        color: #0072BC;
        display: flex;
        font-weight: bold;
        justify-content: center;
        padding: 20px 40px;
        background-color: transparent;
        outline: none;
    }
    .transparent-button svg {
        margin-right: 0.5rem;
    }
    .transparent-button:hover {
        background: #edf5ff;
    }

    .blue-button {
        align-items: center;
        border: 1px solid #0072BC;
        border-radius: 30pt;
        color: #0072BC;
        display: flex;
        font-weight: bold;
        justify-content: center;
        width: 90%;
        padding: 20px 40px;   
    }
    .blue-button:hover {
        background: #0072BC;
        color: white;
    }
    .green-button {
        align-items: center;
        background: #0DB14B;
        border: 1px solid #0DB14B;
        border-radius: 30pt;
        color: white;
        display: flex;
        font-weight: bold;
        justify-content: center;
        width: 100%;
        padding: 20px 40px;   
    }
    .green-button:hover {
        background: #0b8e3d;
        border: 1px solid #075f29;
    }
    .green-button:disabled {
        background-color: #9eddb6;
        border-color: #9eddb6;
    }

    .cfw-page {
        height: auto !important;
        min-height: auto !important;
        max-height: auto !important;
    }
</style>

<script>
import FDCAHeader from '@/components/FDCAInsuranceHeader.vue'
import FDCAFooter from '@/components/FDCAInsuranceFooter.vue'
import FDCAProgress from '@/components/FDCAInsuranceProgress.vue'
import PremiumToggle from '@/components/forms/PremiumToggle.vue'
import { Global } from '@jest/types';
import Globals from '@/assets/scripts/global-functions.js'
import Settings from '@/assets/scripts/settings.json'
import { mapState } from "vuex"
export default {
    name: "FDCAInsurance",
    components: {
        FDCAHeader,
        FDCAFooter,
        FDCAProgress,
        Globals,
        Settings,
        PremiumToggle
    },
    data: () => ({
        googleMapsApiKey:  document.getElementsByName('cfw_global_google_key')[0].content,
        ServiceCurrentStep: 1,
        ServiceProcessCurrentStep: 0,
        EducatorProcessCurrentStep: 0,
        CurrentProcess: "",
        EducatorInsuranceProcess: {},
        ServiceInsuranceProcess: {},
        PathName: "",
        BaseUrl: "",
        Container1: false,
        //this is for header
        EditStatus: false,
        Role: '',

        //progressbar
        hideProgressBar: false,

        //modal v-layout not working
        // overlay: false,
        // drawerStatus: false,
        // header_like_enabled: false,
        // active_modal: 0,

        //check local storage/session 0-not yet resume , 1-resume session
        is_local_storage : true,
        session_id: 0,
        
        //this where i partially store the session storage
        db_session: "",
        is_premium_page: false,
    }),
    //test
    computed: {
      layout () {
        return this.$store.getters.layout
      }
    },
    //endtest
    watch: {
        overlay: function(newVal, oldVal) {
            if(newVal) {
                this.OverflowActive();
            } else {
                this.OverflowDeactivate();
            }
        },
    },
    beforeRouteUpdate (to, from, next) {
        // react to route changes...
        // don't forget to call next()
        alert('hehehe');
    },
    methods: {
        async init() {
            this.CheckWindowPathName();
            this.Role = sessionStorage.getItem("Role");
            //Globals.ValidateProgressEntry(this.ReturnProcess,false);
            //Globals.ValidateProgressEntry(this.ReturnProcess,true);
            //Globals.ValidateProgressEntry(this.ReturnProcess,false);
            this.CheckAbandonedPage();
            this.ImportExternalGoogleMapScript(this.googleMapsApiKey);
            //alert($cookies.isKey("_gid"));
            this.setFullStoryScript();

        },
        RemoveClassFrom(_elementselector, _classnametoremove) {
            /*=====================
            function:
            ► removes selected state of all package
            =====================*/
            let elements = document.getElementsByClassName(_elementselector);
            for(var i = 0; i < elements.length; i++) {
                let item = elements[i];
                item.classList.remove(_classnametoremove);
            }
        },
        AddClassFrom(_elementselector, _classnametoremove) {
            /*=====================
            function:
            ► add selected state of all package
            =====================*/
            let elements = document.getElementsByClassName(_elementselector);
            for(var i = 0; i < elements.length; i++) {
                let item = elements[i];
                item.classList.add(_classnametoremove);
            }
        },
        CheckWindowPathName(){
            this.PathName = window.location.pathname;
            var check_path = (this.PathName).split("/");
            
            if(check_path[1] == 'service'){
                this.Role = 'service';
                //this.ValidateProgressEntry(this.ReturnProcess);
            } else {
                this.Role = 'educator';
                //this.ValidateProgressEntry(this.ReturnProcess);
                //let check =  sessionStorage.getItem("EducatorInsuranceProcess");
            }
            sessionStorage.setItem("Role", this.Role);
            var check_path =[
                              '/educator/premium',  
                              '/educator/final-quote', 
                            ];
            var index = check_path.indexOf(this.PathName);

            if(index != -1) {
                this.hideProgressBar = true;
                this.Container1 = true;
            } else {
                this.hideProgressBar = false;
                this.Container1 = false;
            }
        },
        DisableNextButton(){
            var b = document.getElementById('next-btn').
            b.disabled = true;
            b.classList.remove("next-btn-active");

        },
        EnableNextButton(){
            var b = document.getElementById("next-btn");
            b.disabled = false;
            b.classList.add("next-btn-active");

        },
        DisableNextColorButton(){
            var b = document.getElementById('next-btn').classList.remove("next-btn-active");
        },
        IsThereaProgress(_session) {
            /*=====================
            function:
            ► Checks if there is an existing session storage 
            =====================*/
            let _isprogress = false;
            if((sessionStorage.getItem(_session) != undefined) || sessionStorage.getItem(_session) != null) {
                _isprogress = true;
            }
            return _isprogress;
        },
        ValidateProgressEntry(_session) {
            /*=====================
            function:
            ► Detects if there is a progress from the session storage via IsThereaProgress function
            ► Updates the object from the session storage if there is a progress
            ► Creates / Clears the object if there is no progress from session storage
            =====================*/
            if (this.IsThereaProgress(_session)) {
                this[_session] = JSON.parse(sessionStorage.getItem(_session));
            } else {
                this[_session] = {};
            }
        },
        ValidateCurrentSteps(_session) {
            /*=====================
            function:
            ► Detects if there is a progress from the session storage via IsThereaProgress function
            ► Updates the variable from the session storage if there is a progress
            ► Creates / Clears the variable if there is no progress from session storage
            =====================*/

            if(this.IsThereaProgress(_session)) {
                this[_session] = sessionStorage.getItem(_session);
            } else {
                this[_session] = 0;
            }
        },
        
        OverflowActive() {
            //document.querySelector('html').style.overflowY = "hidden";
            //document.getElementById("main_overlay").classList.add("v-overlay--active");   
        },
        OverflowDeactivate() {
            //document.querySelector('html').style.overflowY = "scroll";
            //document.getElementById("main_overlay").classList.remove("v-overlay--active");
            this.overlay = false;
        },
        UpdateCurrentStep(_number) {
            /* 
            Function: this updates the current step for both educator and service process
            Flow:
                ► Detects the current process
                ► Check the current step of the process if its currently on the same step (_number)
                ► Current step increments if its the same
            */
           
            if(this.CurrentProcess == "EducatorInsuranceProcess") {
                if (this.EducatorProcessCurrentStep == _number) {
                    this.EducatorProcessCurrentStep++;
                     this.EducatorInsuranceProcess.current_step = this.EducatorProcessCurrentStep;
                }
            } else if (this.CurrentProcess == "ServiceInsuranceProcess") {
                if (this.ServiceProcessCurrentStep == _number) {
                    this.ServiceProcessCurrentStep++;
                    this.ServiceProcessCurrentStep.current_step = this.ServiceProcessCurrentStep;
                }
            }
        },
        GoToPage(_route) {
            /* function: a much shorter and meaningful term for calling a page */
            this.$router.push({name: _route});  
        },
        CheckAbandonedPage() {
           /*if(this[this.CurrentProcess].abandoned_page != undefined) {
               this.GoToPage(this[this.CurrentProcess].abandoned_page);
           }*/
        },
        CleanStorage(_session){
            /*=====================
            function:
            ► Remove localstorage and localStorage depends on the params
            ► _session (EducatorInsuranceProcess OR ServiceInsuranceProcess)
            =====================*/

            localStorage.setItem(_session , "");
        },
        ReturnProcess(){
            if(this.Role == "educator"){
                return 'EducatorInsuranceProcess';
            }else{
                return 'ServiceInsuranceProcess';
            }
        },
        ReturnObject(){
            if(this.Role == "educator"){
                return this.EducatorInsuranceProcess;
            }else{
                return this.ServiceInsuranceProcess;
            }
        },
        GoToNextStep(_process, _currentstep, _nextpage) {
            /* process = either EducatorInsuranceProcess or ServiceInsuranceProcess  - NEEDS MORE LOGIC */
            const _new_current_step = Globals.UpdateCurrentStep(this[_process], 1);
            this[_process].current_step = _new_current_step;
            this[_process] = _new_current_step;
            Globals.SessionUpdate(_process, this[_process], false); /* saved to session */
            this.GoToPage(_nextpage);
        },
        EducatorNextStep(_num, _pagename) {
            const _new_current_step = Globals.UpdateCurrentStep(this.EducatorProcessCurrentStep, _num);
            this.EducatorInsuranceProcess.current_step = _new_current_step;
            this.EducatorProcessCurrentStep = _new_current_step;
            
            Globals.SessionUpdate("EducatorInsuranceProcess", this.EducatorInsuranceProcess, this.is_local_storage, this.Role); /* saved to session */
            this.GoToPage(_pagename);
        },
        ServiceNextStep(_num, _pagename) {
            const _new_current_step = Globals.UpdateCurrentStep(this.ServiceProcessCurrentStep, _num);
            this.ServiceInsuranceProcess.current_step = _new_current_step;
            this.ServiceProcessCurrentStep = _new_current_step;
            
            Globals.SessionUpdate("ServiceInsuranceProcess", this.ServiceInsuranceProcess, this.is_local_storage, this.Role); /* saved to session */
            this.GoToPage(_pagename);
        },
        ImportExternalGoogleMapScript(googleMapsApiKey) {
            let gmaps = document.createElement('script');
            gmaps.setAttribute('src', `//maps.googleapis.com/maps/api/js?key=${this.googleMapsApiKey}&libraries=places`);
            document.head.appendChild(gmaps);name="csrf-token"
        },
        setFullStoryScript() {
            let script = document.createElement('script');
            switch(this.environment) {
                case 'uat':
                    script.innerHTML = `
                    window['_fs_debug'] = false;
                    window['_fs_host'] = 'fullstory.com';
                    window['_fs_script'] = 'edge.fullstory.com/s/fs.js';
                    window['_fs_org'] = 'Q03WV';
                    window['_fs_namespace'] = 'FS';
                    (function(m,n,e,t,l,o,g,y){
                        if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
                        g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];
                        o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;
                        y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
                        g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
                        g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
                        g.log = function(a,b) { g("log", [a,b]) };
                        g.consent=function(a){g("consent",!arguments.length||a)};
                        g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
                        g.clearUserCookie=function(){};
                    })(window,document,window['_fs_namespace'],'script','user');
                    `
                    document.head.appendChild(script);
                break;

                case 'prod':
                    script.innerHTML = `
                    window['_fs_debug'] = false;
                    window['_fs_host'] = 'fullstory.com';
                    window['_fs_script'] = 'edge.fullstory.com/s/fs.js';
                    window['_fs_org'] = 'PT8VQ';
                    window['_fs_namespace'] = 'FS';
                    (function(m,n,e,t,l,o,g,y){
                        if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
                        g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];
                        o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;
                        y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
                        g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
                        g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
                        g.log = function(a,b) { g("log", [a,b]) };
                        g.consent=function(a){g("consent",!arguments.length||a)};
                        g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
                        g.clearUserCookie=function(){};
                    })(window,document,window['_fs_namespace'],'script','user');
                    `
                    document.head.appendChild(script);
                break;
            }
        }
        
    },
    mounted() {
        this.init()
    }
}
</script>